import ApiService from "@/common/services/http/api.service";

const EmpresaService = {
  /**
   * Buscar ScoreCards
   * @param usuarioID id do grupo
   * @param params filtros opcionais
   * @returns {*}
   */
  async getEmpresaByUsuario(usuarioID) {
    const { data: result } = await ApiService.get(
      "/EmpresaUsuario/usuario",
      `${usuarioID}`
    );

    return result;
  },
};

export default EmpresaService;
